import { Outlet } from "@tanstack/react-router";
import { Sidebar } from "./Sidebar";
import { MobileHeader } from "./MobileHeader";
import { Toaster } from "./ui/Toaster";

/**
 * The two-column application frame: a persistent sidebar and a scrolling work
 * area. M2 fills the work area with the chat + artifact workspace.
 *
 * There is no top bar above the work area any more (backlog item 13): the
 * three controls it held live in the sidebar's footer, and the header below
 * only exists below `md`, where the sidebar does not.
 */
export function AppShell() {
  return (
    <div className="flex h-dvh w-full overflow-hidden bg-bg">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <MobileHeader />
        <main className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
          <Outlet />
        </main>
      </div>
      {/* Mounted here rather than at the router root: the print routes are
          siblings of this shell, not children, so a printed page cannot grow a
          toast layer (backlog item 11). */}
      <Toaster />
    </div>
  );
}
